module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view projects"
  }, [(_vm.filteredItems.length || _vm.search_filter) ? _c('box', {
    attrs: {
      "label": _vm.filteredItems.length + ' opgaver'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.createNewProject()
      }
    }
  }, [_vm._v("Ny opgave")])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m30"
  }, [_c('inputfield', {
    attrs: {
      "label": "Søg"
    }
  }, [_c('input', {
    ref: "search_filter",
    attrs: {
      "type": "text",
      "placeholder": "Søg"
    },
    domProps: {
      "value": _vm.search_filter
    },
    on: {
      "keyup": _vm.search_filter_updated
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m40"
  }, [_c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.globals.projectStatuses), function(status, status_key, status_i) {
    return _c('option', {
      domProps: {
        "value": status_key
      }
    }, [_vm._v(_vm._s(status.title))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m30"
  })]), _vm._v(" "), (_vm.filteredItems.length) ? _c('table', {
    staticClass: "table-a projects-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Kunde")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Færdig")]), _vm._v(" "), (false && _vm.is_admin) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Tid logget/budget")]) : _vm._e(), _vm._v(" "), (false && _vm.is_admin) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Budget kr.")]) : _vm._e(), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(project, i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.gotoProject(project)
        }
      }
    }, [_vm._v(_vm._s(project.name))])]), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.gotoClient(project)
        }
      }
    }, [_vm._v(_vm._s(_vm.getProjectClient(project).name))])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getProjectStatus(project)) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getProjectDonePct(project)) + "%\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('minipctbar', {
      attrs: {
        "pct": _vm.getProjectDonePct(project)
      }
    })], 1), _vm._v(" "), (false && _vm.is_admin) ? _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(parseInt(project.timelogs_total_hours)) + " /\n\t\t\t\t\t\t" + _vm._s(parseInt(project.budgetted_hours)) + " timer\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (false && _vm.is_admin) ? _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.outputMoney(project.budget, 0)) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimelogger({
            project_key: project['.key']
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  }), 0)]) : _vm._e(), _vm._v(" "), (false) ? [_c('pagination', {
    attrs: {
      "items": _vm.filteredItems,
      "perpage": _vm.projects_perpage,
      "page": _vm.projects_currentpage
    },
    on: {
      "updated": _vm.paginationUpdate
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.filteredItems.length) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewProject()
      }
    }
  }, [_vm._v("Ny opgave")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce5aae68","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Projects.vue
// module id = 625
// module chunks = 1